import React from 'react';
import { AuthLayout } from '@/components/organisms/auth/AuthLayout';
import { LoginForm } from '@/components/organisms/auth/LoginForm';

export const LoginPage: React.FC = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};